import { __assign, __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
function updateGallectionSize(folderId, delta) {
    var gallection, updatedGallection, gallectionSchema, entities;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(function (state) { return getGallectionById(state, folderId); })];
            case 1:
                gallection = _a.sent();
                updatedGallection = __assign(__assign({}, gallection), { size: gallection.size + delta });
                gallectionSchema = gallection.type === 'gallery'
                    ? galleryFolderSchema
                    : collectionFolderSchema;
                entities = normalize(updatedGallection, gallectionSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default updateGallectionSize;
//# sourceMappingURL=updateGallectionSize.js.map